import { Button, type ButtonProps } from "@mantine/core"

import classes from "./AnswerButton.module.css"

export function AnswerButton({ children, ...props }: ButtonProps) {
  return (
    <Button disabled classNames={classes} fz="lg" flex="0 0 auto" {...props}>
      {children}
    </Button>
  )
}
